import { Add, DeleteOutline, Edit } from "@mui/icons-material";
import { Autocomplete, BottomNavigation, BottomNavigationAction, Box, TextField } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import defaultImage from "../../assets/svg/defultImage.svg";
import DailyCheckVanProfile from "../../components/DailyCheckVanProfile";
import Equipment from "../../components/Equipment";
import MaintenanceVanProfile from "../../components/MaintenanceVanProfile";
import DeleteModal from "../../components/Modals/DeleteModal";
import License from "../../components/Modals/License";
import OrderDetailsCard from "../../components/OrderDetailsCard/OrderDetailsCard ";
import StaffVans from "../../components/StaffVans";
import WorkingDays from "../../components/WorkingDays";
import { VEHICLES_LIST } from "../../URLs/Apis";
import { newHost } from "../Categories/CategoryProfile";
import { newImageUrl } from "../Manufacturers/ManufactureProfile";



const VanProfile = () => {
  const [vehicleById, setVehicleBYId] = useState({});
  const [isEdit, setIsEdit] = useState(false)
  const { user } = useSelector((state) => state.auth);
  const token = user?.token
  const [show, setShow] = useState(false);
  const [vehicleBrands, setVehicleBrands] = useState([])
  const [showDelete, setShowDelete] = useState(false)
  const [properties, setProperties] = useState([])
  const [imagePreview, setImagePreview] = useState(null)
  const [tabValue, setTabValue] = useState(0)

  const FileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => {
      setImagePreview(reader.result);
      setValue("profile_photo", file);
    };
    reader.readAsDataURL(file);
  };

  const handleClose = () => {
    setShow(false)
    reset({
      model_id: "",
      brand_id: null,
      year: "",
      odometer_reading: "",
      chassis_number: "",
      plate_number: "",
      properties: [
        {
          property_id: "",
          value_id: ""
        }


      ]
    })
    setImagePreview(null)
  }

  const { id: vanId } = useParams();

  const getVehicleById = async () => {
    try {
      const response = await axios.get(
        `${VEHICLES_LIST}/${vanId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setVehicleBYId(response.data.data.door_step_vehicle);
      console.log("vanbyid", response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getAllVehiclesSpecifications = async () => {
    try {
      const response = await axios.get(`${newHost}cars/specifications`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      )
      setVehicleBrands(response.data.data.brands || null)
      setProperties(response.data.data.properties)
    } catch (error) {
    }
  }

 

  const submitVehicles = async (data) => {
    console.log(data);
    const formData = new FormData();
    if (data.profile_photo && data.profile_photo !== null) {
      formData.append("profile_photo", data.profile_photo);
    }
    formData.append("brand_id", data.brand_id);
    formData.append("model_id", data.model_id);
    formData.append("year", data.year);
    formData.append("odometer_reading", data.odometer_reading);
    formData.append("chassis_number", data.chassis_number);
    formData.append("plate_number", data.plate_number);
    data.properties.forEach((property, index) => {
      formData.append(`properties[${index}][property_id]`, property.property_id)
      formData.append(`properties[${index}][value_id]`, property.value_id)
    })
    formData.append("_method", "PATCH");
    try {
      const response = await axios.post(`${newHost}portal/door_step_vehicles/${vanId}`, formData, {
        headers: { Authorization: `Bearer ${token}` }
      })
      toast.success(response.data.message)
      setShow(false)
      getVehicleById()
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message)
    }
  }

  const {
    register,
    handleSubmit,
    setValue,
    control,
    reset,
    formState: { errors },
    watch
  } = useForm({
    defaultValues: {
      model_id: "",
      brand_id: null,
      year: "",
      odometer_reading: "",
      chassis_number: "",
      plate_number: "",
      properties: [
        {
          property_id: "",
          value_id: ""
        }

      ]
    },
  })



  useEffect(() => {
    getVehicleById()
  }, [])

  const handleUpdateVehicle = async (vehicle) => {
    console.log(vehicle);
    setIsEdit(true)
    setShow(true);
    if (vehicle?.profile_photo_url) {
      setImagePreview(`${newImageUrl}${vehicle?.profile_photo_url}`);
    } else {
      setImagePreview(null);
    }
    reset({
      brand_id: vehicle.model?.brand_id || "",
      model_id: vehicle.model_id || "",
      year: vehicle.year || "",
      odometer_reading: vehicle.odometer_reading || "",
      chassis_number: vehicle.chassis_number || "",
      plate_number: vehicle.plate_number || "",
      properties: vehicle.properties?.length
        ? vehicle.properties.map((prop) => ({
          property_id: prop?.property?.id,
          value_id: prop?.value?.id
        }))
        : [{ property_id: "", value_id: "" }]
    });
  };

  useEffect(() => {
    if (isEdit && vehicleById) {
      const selectedBrand = vehicleBrands.find(b => b.id === vehicleById.model?.brand_id);
      const selectedModel = selectedBrand?.models.find(m => m.id === vehicleById.model_id);

      if (selectedBrand) {
        setValue("brand_id", selectedBrand.id);
      }
      if (selectedModel) {
        setValue("model_id", selectedModel.id);
      }
      if (vehicleById.year) {
        setValue("year", vehicleById.year);
      }
    }
  }, [vehicleBrands, vehicleById, isEdit, setValue]);

  const navigate = useNavigate()

  const handleDeleteVehicleShow = () => {
    setShowDelete(true)
  }
  const handleDeleteVehicleClose = () => {
    setShowDelete(false)
  }

  const deleteVehicle = async () => {
    try {
      const response = await axios.delete(`${newHost}portal/door_step_vehicles/${vanId}`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      toast.success(response.data.data.message)
      setShowDelete(false)
      navigate("/vehicles")
    } catch (error) {
      toast.error(error.response.data.message)
    }
  }

  useEffect(() => {
    getAllVehiclesSpecifications();
  }, []);

  return (
    <>
      <DeleteModal
        showDelete={showDelete}
        handleDeleteClose={handleDeleteVehicleClose}
        textMessage={" Are you sure you want to delete this Vehicle?"}
        deleteFunction={deleteVehicle}
      />
      <Modal show={show} onHide={handleClose} dialogClassName="custom-modal-size">
        <Modal.Header style={{ backgroundColor: "#D5D5D5" }}>
          <Modal.Title className="text-black">Update Vehicle</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{}}>
          <form action="" onSubmit={handleSubmit(submitVehicles)}>
            <div className="d-flex justify-content-between align-items-center p-4 company-logo-upload input-group-responsive">
              <div className="d-flex align-items-center upload-file-responsive">
                <div className="">
                  <img
                    className="w-50"
                    src={
                      imagePreview
                        ? imagePreview
                        :
                        defaultImage
                    }
                    alt="profile_photo"
                  />
                </div>



                {imagePreview ? null : <p className="fw-bold my-0 mx-2 supplier-label-size">Upload an image. Max size 2MB</p>
                }

              </div>
              <label htmlFor="profile_photo" className="btn btn-light">

                Browser
                <input onChange={FileChange} type="file" id="profile_photo" className="d-none " />


              </label>

            </div>
            <div className="row mt-3">

              <div className="col-xl-4 col-12">
                <div className="">
                  <label htmlFor="">Brands</label>

                  <Controller
                    name="brand_id"
                    control={control}
                    rules={{
                      required: `Brand is required`
                    }}
                    render={({ field }) => {
                      const options = vehicleBrands.map(option => ({
                        label: option.name,
                        id: option.id,
                      }));

                      return (
                        <Autocomplete
                          size="small"
                          options={options}
                          value={options.find(opt => opt.id == field.value) || null}

                          onChange={(e, item) => {
                            field.onChange(item ? item.id : null);
                          }}

                          renderOption={(props, option) => (
                            <li {...props} className="p-2">
                              {option.label}
                            </li>
                          )}

                          renderInput={(params) => (
                            <TextField {...params} placeholder="Select Brand"
                              error={!!errors?.brand_id}

                            />
                          )}
                        />
                      );
                    }}
                  />
                  {errors?.brand_id && (
                    <p style={{ fontSize: "13px" }} className="text-danger my-1 fw-semibold text-center">
                      {errors?.brand_id?.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-xl-4 col-12">
                <div className="">
                  <label htmlFor="">Model</label>
                  <Controller
                    name={`model_id`}
                    control={control}

                    render={({ field }) => {
                      const selectedBrandId = watch(`brand_id`);
                      const selectedBrand = vehicleBrands.find(
                        (brand) => brand.id == selectedBrandId
                      );
                      const availableModels = selectedBrand?.models || [];
                      const options = availableModels.map(option => ({
                        label: option.name,
                        id: option.id,
                      }));

                      return (
                        <Autocomplete
                          size="small"
                          options={options}
                          rules={{
                            required: `Model is required`
                          }}
                          value={options.find(opt => opt.id == field.value) || null}

                          onChange={(e, item) => {
                            field.onChange(item ? item.id : null);
                          }}

                          renderOption={(props, option) => (
                            <li {...props} className="p-2">
                              {option.label}
                            </li>
                          )}

                          renderInput={(params) => (
                            <TextField {...params} placeholder="Select Model"
                              error={!!errors?.model_id}
                            />
                          )}
                        />
                      );
                    }
                    }
                  />
                  {errors?.model_id && (
                    <p style={{ fontSize: "13px" }} className="text-danger my-1 fw-semibold text-center">
                      {errors?.model_id?.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-xl-4 col-12">
                <div className="">
                  <label htmlFor="">Year</label>
                  <Controller
                    name={`year`}
                    rules={{
                      required: `Year is required`
                    }}
                    control={control}
                    render={({ field }) => {
                      const selectedBrandId = watch("brand_id");
                      const selectedModelId = watch("model_id");

                      const selectedBrand = vehicleBrands.find(
                        (brand) => brand.id == selectedBrandId
                      );

                      const selectedModel = selectedBrand?.models.find(
                        (model) => model.id == selectedModelId
                      );

                      const availableYear = selectedModel?.active_years || [];
                      const options = availableYear.map(option => ({
                        label: option,
                        id: option,
                      }));

                      return (
                        <Autocomplete
                          size="small"
                          options={options}
                          value={options.find(opt => opt.id == field.value) || null}

                          onChange={(e, item) => {
                            field.onChange(item ? item.id : null);
                          }}

                          renderOption={(props, option) => (
                            <li {...props} className="p-2">
                              {option.label}
                            </li>
                          )}

                          renderInput={(params) => (
                            <TextField {...params} placeholder="Select Year"
                              error={!!errors?.year}
                            />
                          )}
                        />
                      );

                    }}
                  />
                  {errors?.year && (
                    <p style={{ fontSize: "13px" }} className="text-danger my-1 fw-semibold text-center">
                      {errors?.year?.message}
                    </p>
                  )}

                </div>
              </div>
            </div>
            <div className="row my-1">

              <div className="col-xl-4 col-12">
                <div className="">
                  <label htmlFor="">Plate Number</label>
                  <TextField
                    size="small"
                    style={{ outlineColor: "black", }}
                    className='w-100 ' type='text' placeholder='Add plate number'
                    {...register("plate_number",
                      {
                        required: "plate Number is Required"
                      }
                    )}
                    error={!!errors?.plate_number}
                  />
                  {errors?.plate_number && (
                    <p style={{ fontSize: "13px" }} className="text-danger my-1 fw-semibold text-center">
                      {errors?.plate_number?.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-xl-4 col-12">
                <div className="">
                  <label htmlFor="">Chassis Number</label>
                  <TextField
                    size="small"
                    style={{ outlineColor: "black", }}
                    className='w-100 ' type='text' placeholder='Add chassis number'
                    {...register("chassis_number")}
                  />
                </div>
              </div>
              <div className="col-xl-4 col-12">
                <div className="">
                  <label className="" htmlFor="">Odometer Reading</label>
                  <TextField
                    size="small"
                    style={{ outlineColor: "black", }}
                    className='w-100 ' type='text' placeholder='Add odometer reading'
                    {...register("odometer_reading")}
                  />
                </div>
              </div>
            </div>

            <div className="row mt-2">
              {properties.map((prop, index) => (
                <div key={prop.id} className="col-xl-4 col-12 my-2">
                  <label>{prop.name}</label>

                  <Controller
                    name={`properties.${index}.value_id`}
                    control={control}
                    rules={{
                      required: `${prop.name} is required`
                    }}
                    render={({ field }) => (
                      <Autocomplete
                        size="small"
                        options={prop.values.map((option) => ({
                          label: option.value,
                          id: option.id,
                        }))}
                        value={
                          prop.values
                            .map(v => ({ label: v.value, id: v.id }))
                            .find(v => v.id == field.value) || null
                        }
                        onChange={(e, item) => {
                          field.onChange(item ? item.id : "")
                        }}
                        renderOption={(props, option) => (
                          <li {...props} className="p-2">
                            <div className="label-size m-0">{option.label}</div>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder={`Select ${prop.name}`}
                            error={!!errors?.properties?.[index]?.value_id}
                          />
                        )}
                      />
                    )}

                  />
                  {errors?.properties?.[index]?.value_id && (
                    <p style={{ fontSize: "13px" }} className="text-danger my-1 fw-semibold text-center">
                      {errors?.properties?.[index]?.value_id?.message}
                    </p>
                  )}
                </div>
              ))}
            </div>

         
            <div className="d-flex gap-3 justify-content-center align-items-center custom-card-sm my-3">
              <button className="btn btn-dark px-5">Save</button>
              <button type="reset" onClick={handleClose} className="btn btn-light px-5">Cancel</button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      <div className="m-4">
        <div className="row">
          <div className="col-lg-3 col-md-4 col-sm-12 p-0 ">
            <div className="col-md-12 p-1">
              <div className="p-3 card-style">
                <h5 className="fw-bold">{vehicleById.reference ? vehicleById.reference : `Van # ${vehicleById.id}`}</h5>
                <div className="d-flex justify-content-center align-items-center">
                  <img style={{ maxWidth: "150px" }} className="img-fluid m-auto" src={vehicleById.profile_photo_url ? `${newImageUrl}${vehicleById.profile_photo_url}` : defaultImage} alt="Van Profile" />
                </div>
                <div className="card-body">
                  <h5 className="card-title custom-card-sm d-flex align-items-center  gap-1">
                    {/* <div className="d-flex align-items-center justify-content-between "></div> */}
                    <img style={{ maxWidth: "30px" }} className="img-fluid" src={vehicleById.model?.brand?.logo_path ? `${newImageUrl}${vehicleById.model?.brand?.logo_path}` : defaultImage} alt="Logo" />
                    {vehicleById.name}

                  </h5>
                  <div className="my-2">
                    <div className="upload-file-responsive">
                      <h6 className="main-text-color label-van m-0">Van Capacity</h6>
                      <div className="progress my-1 " style={{ height: "10px" }}>
                        <div
                          className={` ${vehicleById?.capacity > 7 && vehicleById?.capacity <= 10
                            ? "bg-success"
                            : vehicleById?.capacity > 3 && vehicleById?.capacity < 7
                              ? "bg-warning"
                              : vehicleById?.capacity === 0
                                ? "bg-transparent"
                                : vehicleById?.capacity > 0 && vehicleById?.capacity < 3
                                  ? "bg-danger"
                                  : ""
                            }`}
                          role="progressbar"
                          style={{
                            width:
                              vehicleById?.capacity === 10
                                ? "100%"
                                : vehicleById?.capacity > 7
                                  ? "90%"
                                  : vehicleById?.capacity > 3 &&
                                    vehicleById?.capacity < 7
                                    ? "50%"
                                    : vehicleById?.capacity > 0 &&
                                      vehicleById?.capacity < 3
                                      ? "30%"
                                      : vehicleById?.capacity === 0
                                        ? "0%"
                                        : "",
                          }}
                          aria-valuenow={vehicleById?.capacity}
                          aria-valuemin="0"
                          aria-valuemax="10"
                        ></div>
                      </div>
                    </div>

                    <div className="upload-file-responsive">
                      <h6 className="main-text-color label-van m-0">Working hours</h6>
                      <div className="progress my-1 " style={{ height: "10px" }}>
                        <div
                          className={` ${vehicleById?.capacity > 7 && vehicleById?.capacity <= 10
                            ? "bg-success"
                            : vehicleById?.capacity > 3 && vehicleById?.capacity < 7
                              ? "bg-warning"
                              : vehicleById?.capacity === 0
                                ? "bg-transparent"
                                : vehicleById?.capacity > 0 && vehicleById?.capacity < 3
                                  ? "bg-danger"
                                  : ""
                            }`}
                          role="progressbar"
                          style={{
                            width:
                              vehicleById?.capacity === 10
                                ? "100%"
                                : vehicleById?.capacity > 7
                                  ? "90%"
                                  : vehicleById?.capacity > 3 &&
                                    vehicleById?.capacity < 7
                                    ? "50%"
                                    : vehicleById?.capacity > 0 &&
                                      vehicleById?.capacity < 3
                                      ? "30%"
                                      : vehicleById?.capacity === 0
                                        ? "0%"
                                        : "",
                          }}
                          aria-valuenow={vehicleById?.capacity}
                          aria-valuemin="0"
                          aria-valuemax="10"
                        ></div>
                      </div>
                    </div>

                    <div className="d-flex flex-wrap custom-card-sm justify-content-between align-items-center mt-3">
                      <h6 className="main-text-color label-van m-0">Services Categories</h6>

                <div className="">
                {vehicleById.service_categories?.length > 0 ? (
                  <>
                    {vehicleById.service_categories.map((service) => (
                      <img
                        className="service-icon"
                        src={newImageUrl + service.icon_url}
                        alt="service-icon"
                      />
                    ))}
                  </>
                ) : (
                  <div className="">
                    <p className="m-0 label-van">No Available Services</p>
                  </div>
                )}
              </div>
                    </div>
                    <div className="d-flex  custom-card-sm justify-content-between align-items-center my-1">
                      <h6 className="main-text-color m-0 label-van">Supervisor</h6>
                      <div className="">
                        {vehicleById?.supervisor?.length > 0 ? (
                          vehicleById.supervisor.map((supervisor) =>
                            <h6 key={supervisor.id} className=" m-0 label-van">{supervisor.name}</h6>

                          )
                        ) : (
                          <button className=" border-0 bg-transparent button-size">
                            Add Supervisor
                            <Add sx={{ fontSize: "12px" }} />
                          </button>)}
                      </div>
                    </div>
                    {vehicleById.current_stuff?.length > 0 ?

                      vehicleById.current_stuff?.map((stuff) =>
                        <div key={stuff.id} className="d-flex  custom-card-sm justify-content-between align-items-center my-1">


                          <h6 className="main-text-color label-van m-0">{`${stuff.job_title?.title}`}</h6>
                          <h6 className="label-van m-0">{stuff?.name}</h6>
                        </div>


                      ) :
                      <div className="d-flex custom-card-sm justify-content-between align-items-center my-1">

                        <h6 className="main-text-color m-0 label-van">Staffs</h6>

                        <button
                          onClick={() => setTabValue(1)}
                          className=" border-0 bg-transparent button-size"
                        >
                          Add Staff
                          <Add sx={{ fontSize: "12px" }} />

                        </button>
                      </div>
                    }

                    <div className="">
                      <div className="d-flex align-items-center justify-content-between">
                        <h5 className="m-0">Van Info</h5>

                        <div

                          className="d-flex align-items-center  my-1">
                          <div onClick={() => handleUpdateVehicle(vehicleById)} >
                            <Edit sx={{ cursor: "pointer" }} color="action" />
                          </div>
                          <div onClick={() => handleDeleteVehicleShow()} >
                            <DeleteOutline sx={{ cursor: "pointer" }} color="error" />
                          </div>

                        </div>
                      </div>
                      <div className="my-3">
                        <div className="d-flex custom-card-sm justify-content-between align-items-center my-2">
                          <h6 className="main-text-color label-van m-0">Plate Number</h6>
                          <h6 className="m-0 label-van">{vehicleById.plate_number}</h6>
                        </div>
                        <div className="d-flex custom-card-sm justify-content-between align-items-center my-2">
                          <h6 className="main-text-color label-van m-0">Chassis Number</h6>
                          <h6 className="m-0 label-van">{vehicleById.chassis_number}</h6>
                        </div>
                        <div className="d-flex custom-card-sm justify-content-between align-items-center my-2">
                          <h6 className="main-text-color label-van m-0">Odometer Reading</h6>
                          <h6 className="m-0 label-van">{vehicleById.odometer_reading}</h6>
                        </div>
                        <div className="my-3">
                          <div className="">
                            <h6 className="main-text-color m-0">Properties:</h6>
                            <ul className="my-2">
                              {vehicleById?.properties?.length > 0 ? vehicleById.properties.map((property) =>
                                <>
                                  <div key={property.id} className="d-flex custom-card-sm justify-content-between align-items-center my-1">

                                    <li className="m-0 label-van">{property.property?.name}</li>
                                    <p className="m-0 label-van">{property.value?.value}</p>
                                  </div>
                                </>


                              ) : null}

                            </ul>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div className="col-lg-9 col-md-8 col-sm-12 p-0">
            <div className="p-3">
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <BottomNavigation
                  showLabels
                  value={tabValue}
                  onChange={(event, newValue) => setTabValue(newValue)}
                  sx={{
                    backgroundColor: {
                      xs: "transparent",
                      sm: "#f8f9fa"
                    },
                    height: "auto",
                    padding: 1,
                    borderRadius: {
                      sm: "10px",
                      xs: 0

                    },
                    width: "100%",
                    flexDirection: {
                      xs: "column",
                      sm: "row",
                    },

                    alignItems: {
                      xs: "center",
                    }
                    ,
                    ".MuiBottomNavigationAction-root": {
                      fontSize: "15px",
                      minWidth: 0,
                      padding: "8px 12px",
                      justifyContent: "center",
                      width: "100%",
                    },
                    ".Mui-selected": {
                      fontWeight: "bold",
                      fontSize:"12px"
                    },
                  }}
                >
                  <BottomNavigationAction label="Order" />
                  <BottomNavigationAction label="Staffs" />

                  <BottomNavigationAction label="Working Days" />
                  <BottomNavigationAction label="Equipments" />
                  {/* <BottomNavigationAction label="Tools" /> */}
                  <BottomNavigationAction label="Documentations" />
                  <BottomNavigationAction label="Maintenance History" />
                  <BottomNavigationAction label="Daily Checks" />
                </BottomNavigation>
              </Box>
              {tabValue == 0 ? <>
                <OrderDetailsCard />
              </> :
                tabValue == 1 ? <StaffVans getVehicleById={getVehicleById} vehicleById={vehicleById} /> :
                  tabValue == 2 ? <WorkingDays /> :
                    tabValue == 3 ? <Equipment getVehicleById={getVehicleById} vehicleById={vehicleById} /> :
                      tabValue == 4 ? <License /> : tabValue == 5 ? <MaintenanceVanProfile /> : <DailyCheckVanProfile/>

              }
            </div>
            {/* {activePage === "orders" && <OrderDetailsCard />}
         
          {activePage === "License" && <License /> }
          {activePage === "StaffVans" && <StaffVans vanId={vanId} />}
          {activePage === "Equipment" && <Equipment vanId={vanId} />}
          {activePage === "WorkingDays" && <WorkingDays />}
          {activePage === "Services" && (
            <ServicesVanProfile vehicleById={vehicleById} vanId={vanId} />
          )} */}
          </div>
        </div>
      </div>
    </>
  );
};

export default VanProfile;
